module.exports = "/_next/static/images/shashwat-fc07ab3738d571d03f09e6fb68bd1e7b.png";